import { apiClient } from './api';

interface StartSimulationResponse {
  success: boolean;
  data: {
    orderId: string;
    orderNumber: string;
    startLat: number;
    startLng: number;
    endLat: number;
    endLng: number;
    distance: number;
    durationSeconds: number;
    message: string;
  };
}

export const demoService = {
  async startSimulation(orderId: string): Promise<StartSimulationResponse['data']> {
    const response = await apiClient.post<StartSimulationResponse['data']>(
      `/demo/start-simulation/${orderId}`
    );
    return response.data.data;
  },
};
